import { _getEventDateSessionsUrl, type SessionsApiParams } from './constants';

export const getEventDateSessions = async ({
    env,
    eventId,
    date,
    tzIdentifier,
}: SessionsApiParams) => {
    try {
        const response = await fetch(
            _getEventDateSessionsUrl({
                env,
                eventId,
                date,
                tzIdentifier,
            }),
            {
                method: 'GET',
                credentials: 'include',
            },
        );

        const body = await response.json();
        if (body.error) {
            throw new Error(
                `Checkout Fairy returned a body describing an error: ${body.error} (full body: ${body})`,
            );
        }

        return body;
    } catch (error) {
        console.log('error', error);
        throw new Error(`Checkout Fairy returned an error: ${error.message}`);
    }
};
